import { t } from "@/lib/i18n";

// Палитра и эмодзи тегов. id цвета совпадают с допустимыми на сервере (backend/hub/api/tags.py COLORS).
export const tagColors = [
  { id: "graphite", label: t("Графит"), hex: "#4b5563" },
  { id: "coral", label: t("Коралловый"), hex: "#f97316" },
  { id: "amber", label: t("Янтарный"), hex: "#f59e0b" },
  { id: "lemon", label: t("Лимонный"), hex: "#eab308" },
  { id: "green", label: t("Зелёный"), hex: "#22c55e" },
  { id: "teal", label: t("Бирюзовый"), hex: "#14b8a6" },
  { id: "rose", label: t("Розовый"), hex: "#f43f5e" },
  { id: "lime", label: t("Лаймовый"), hex: "#84cc16" },
];

export const tagEmojis = ["🏷️", "🆕", "💰", "🚚", "⚠️", "🤖", "🔥", "📄", "🎓", "⭐", "🛠️", "❓", "✅", "📦", "🧾", "🕒"];
